import React from 'react';
import config from '../config';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="site-footer" aria-label="网站页脚">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <a className="footer-brand-row" href="#heroSec" aria-label="非凡工作，返回页面顶部">
              <span className="footer-mark" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M16.6 5.6a8 8 0 1 0 0 12.8" stroke="#fff" strokeWidth="2.7" strokeLinecap="round"/>
                  <circle cx="15.3" cy="12" r="2.5" fill="#fff"/>
                </svg>
              </span>
              <strong>{config.site.name}</strong>
            </a>
            <p>把每个人的工作方法做成可运行、可分享、可继续修改的 APP，让一次创造持续流动。</p>
            <span className="footer-audience">人人做 APP，APP 来接客</span>
          </div>

          <nav className="footer-nav" aria-label="页脚导航">
            <div className="footer-col">
              <b>产品</b>
              <a 
                className="footer-link footer-primary-link" 
                href={config.market.home}
                target="_blank" 
                rel="noopener noreferrer"
              >
                应用市场
              </a>
              <a href="#heroSec">接待场景</a>
              <a href="#orbitSec">数字资产</a>
              <a href="#modules">做应用难题</a>
            </div>

            <div className="footer-col">
              <b>开始使用</b>
              <a 
                className="footer-link footer-primary-link" 
                href={config.market.home}
                target="_blank" 
                rel="noopener noreferrer"
              >
                浏览应用
              </a>
              <a 
                href={config.market.publish}
                target="_blank" 
                rel="noopener noreferrer"
              >
                发布应用
              </a>
              <a 
                href={config.market.account}
                target="_blank" 
                rel="noopener noreferrer"
              >
                管理我的应用
              </a>
            </div>

            <div className="footer-col">
              <b>帮助</b>
              <a href="#faq">常见问题</a>
              <a href="#faqwhat-get">HTML / ZIP 说明</a>
              <a href="#heroSec">返回顶部</a>
            </div>
          </nav>
        </div>

        <div className="footer-bottom">
          <a href="#heroSec" aria-label="非凡工作，返回页面顶部">
            © 2026 {config.site.name} · {config.site.domain}
          </a>
          <div className="footer-trust" aria-label="产品使用特点">
            <a href="#faqneed-login">无需登录</a>
            <a href="#faqwhat-get">HTML 可运行 · ZIP 可获取</a>
            <a 
              href={config.market.home}
              target="_blank" 
              rel="noopener noreferrer"
            >
              手机与电脑可用 <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
